<nh-form
  [individuals]="individuals"
  [formGroup]="getForm()"
  [mode]="mode"
  (validate)="onValidate($event)"
>
  <section [formGroup]="getControl('data')">
    <h1 class="section-header">
      {{ "OTHER_HEALTHCARE_STATIC_TEXT1" | globalTranslate }}
    </h1>
    <hr />
    <nh-field
      id="otbe_medicareIndSw"
      [mandatory]="false"
      [attr.aria-required]="false"
      label="{{ 'OTHER_HEALTHCARE_STATIC_TEXT2' | globalTranslate }}"
      class="label-section"
      [col9]="true"
    >
      <nh-popover
        class="ps-1"
        [content]="'OTHER_HEALTHCARE_STATIC_TEXT4' | globalTranslate"
      ></nh-popover>
      <div class="hint">
        {{ "OTHER_HEALTHCARE_STATIC_TEXT3" | globalTranslate }}
      </div>
      <select
        nhTranslate
        name="medicareIndSw"
        [attr.aria-label]="'OTHER_HEALTHCARE_STATIC_TEXT2' | globalTranslate"
        (change)="onProfileDataChange('medicareIndSw', 'medicareIndSwOpt')"
        [items]="tableCodeValue('YESNO', 'extras.helpers.medicareIndSw')"
        [formControl]="getControl('extras.helpers.medicareIndSw')"
      ></select>
    </nh-field>

    @if (isY('extras.helpers.medicareIndSw')) {
    <div>
      <label for="Medicare Costs" class="label-section"
        ><span class="text-danger" aria-hidden="true">*&nbsp;</span
        >{{ "OTHER_HEALTHCARE_STATIC_TEXT5" | globalTranslate }}
      </label>
      <nh-checkbox-list
        uniqueString="MEDC"
        [checkboxGroup]="this.getControl('extras.helpers.medicareIndSwOpt')"
        [referenceTable]="individualTable"
        [ariaRequired]="true"
        [globalLangTranslate]="false"
        [fromCheckboxList]="true"
      ></nh-checkbox-list>
    </div>
    }
    <nh-alert
      type="danger"
      [isOpen]="
        isY('extras.helpers.medicareIndSw') && !getCtrl('medicareIndSw')
      "
    >
      <div class="row">
        <div class="col-auto icon">
          <img
            src="../../../../../assets/images/Icons/⚛️ icons-alert-circle-outline.svg"
            alt=""
          />
        </div>
        <div class="col message">
          <span>{{ "REQUIRED" | globalTranslate }}</span>
        </div>
      </div>
    </nh-alert>
    <br />

    <h2 class="section-header">
      {{ "OTHER_HEALTHCARE_STATIC_TEXT40" | globalTranslate }}
    </h2>
    <hr />
    <nh-field
      id="otbe_ssiBenefitsSw"
      [mandatory]="false"
      [attr.aria-required]="false"
      label="{{ 'OTHER_HEALTHCARE_STATIC_TEXT41' | globalTranslate }}"
      class="label-section"
    >
      <nh-popover
        class="ps-1"
        [content]="'OTHER_HEALTHCARE_STATIC_TEXT42' | globalTranslate"
      ></nh-popover>
      <select
        nhTranslate
        name="ssiBenefitsSw"
        [attr.aria-label]="'OTHER_HEALTHCARE_STATIC_TEXT41' | globalTranslate"
        (change)="onProfileDataChange('ssiBenefitsSw', 'ssiBenefitsSwOpt')"
        [items]="tableCodeValue('YESNO', 'extras.helpers.ssiBenefitsSw')"
        [formControl]="getControl('extras.helpers.ssiBenefitsSw')"
      ></select>
    </nh-field>

    @if (isY('extras.helpers.ssiBenefitsSw')) {
    <div>
      <label for="Pickle" class="label-section"
        ><span class="text-danger" aria-hidden="true">*&nbsp;</span
        >{{ "OTHER_HEALTHCARE_STATIC_TEXT5" | globalTranslate }}</label
      >
      <nh-checkbox-list
        uniqueString="PKL"
        [checkboxGroup]="this.getControl('extras.helpers.ssiBenefitsSwOpt')"
        [referenceTable]="individualTable"
        [ariaRequired]="true"
        [globalLangTranslate]="false"
        [fromCheckboxList]="true"
      ></nh-checkbox-list>
    </div>
    }
    <nh-alert
      type="danger"
      [isOpen]="
        isY('extras.helpers.ssiBenefitsSw') && !getCtrl('ssiBenefitsSw')
      "
    >
      <div class="row">
        <div class="col-auto icon">
          <img
            src="../../../../../assets/images/Icons/⚛️ icons-alert-circle-outline.svg"
            alt=""
          />
        </div>
        <div class="col message">
          <span>{{ "REQUIRED" | globalTranslate }}</span>
        </div>
      </div>
    </nh-alert>
    <br />
    <div>
      <h2 class="section-header">
        {{ "OTHER_HEALTHCARE_STATIC_TEXT6" | globalTranslate }}
      </h2>
      <hr />
      @if ((!isPresumptive && !isFullCoverageApp && !isPPFRM) || isKepro) {
      <nh-field
        id="otbe_brstCervCancerSw"
        [mandatory]="false"
        [attr.aria-required]="false"
        label="{{ 'OTHER_HEALTHCARE_STATIC_TEXT7' | globalTranslate }}"
        class="label-section"
      >
        <nh-popover
          class="ps-1"
          [content]="'OTHER_HEALTHCARE_STATIC_TEXT8' | globalTranslate"
        ></nh-popover>
        <select
          nhTranslate
          name="brstCervCancerSw"
          [attr.aria-label]="'OTHER_HEALTHCARE_STATIC_TEXT7' | globalTranslate"
          (change)="
            onProfileDataChange('brstCervCancerSw', 'brstCervCancerSwOpt')
          "
          [items]="tableCodeValue('YESNO', 'extras.helpers.brstCervCancerSw')"
          [formControl]="getControl('extras.helpers.brstCervCancerSw')"
        ></select>
      </nh-field>
      } @if ((isPresumptive || isFullCoverageApp || isPPFRM) && !isKepro) {
      <nh-field
        id="otbe_brstCervCancerSw"
        [mandatory]="false"
        [attr.aria-required]="false"
        label="{{ 'OTHER_HEALTHCARE_STATIC_TEXT43' | globalTranslate }}"
        class="label-section"
      >
        <nh-popover
          class="ps-1"
          [content]="'OTHER_HEALTHCARE_STATIC_TEXT8' | globalTranslate"
        ></nh-popover>
        <select
          nhTranslate
          name="brstCervCancerSw"
          [attr.aria-label]="'OTHER_HEALTHCARE_STATIC_TEXT43' | globalTranslate"
          (change)="
            onProfileDataChange('brstCervCancerSw', 'brstCervCancerSwOpt')
          "
          [items]="tableCodeValue('YESNO', 'extras.helpers.brstCervCancerSw')"
          [formControl]="getControl('extras.helpers.brstCervCancerSw')"
          [attr.disabled]="isBrstCervCancerDisabled ? true : null"
        ></select>
      </nh-field>
      }
      <nh-alert
        type="warning"
        [isOpen]="isY('extras.helpers.brstCervCancerSw')"
      >
        <div class="row">
          <div class="col-auto icon">
            <img
              src="../../../../../assets/images/Icons/⚛️ icons-warning-outline.svg"
              alt=""
            />
          </div>
          <div class="col message">
            <span>
              @if (isPresumptiveBcc) {
                {{ "BCC_BANNER_IN_OHC_SCREEN" | globalTranslate }}
              } @else {
                {{ "OTHER_HEALTHCARE_STATIC_TEXT9" | globalTranslate }}
              }
            </span>
          </div>
        </div>
      </nh-alert>
      @if (isY('extras.helpers.brstCervCancerSw') && !isPresumptiveBcc) {
      <div>
        <label for="Breast or Cervical Cancer" class="label-section"
          ><span class="text-danger" aria-hidden="true">*&nbsp;</span
          >{{ "OTHER_HEALTHCARE_STATIC_TEXT5" | globalTranslate }}</label
        >
        <nh-checkbox-list
          uniqueString="BCC"
          [checkboxGroup]="
            this.getControl('extras.helpers.brstCervCancerSwOpt')
          "
          [referenceTable]="individualTable"
          [ariaRequired]="true"
          [globalLangTranslate]="false"
          [fromCheckboxList]="true"
        ></nh-checkbox-list>
      </div>
      }
      @if (isY('extras.helpers.brstCervCancerSw') && isPresumptiveBcc) {
      <div>
        <label for="Breast or Cervical Cancer" class="label-section"
          ><span class="text-danger" aria-hidden="true">*&nbsp;</span
          >{{ "OTHER_HEALTHCARE_STATIC_TEXT5" | globalTranslate }}</label
        >
        <nh-checkbox-list
          uniqueString="BCC"
          [checkboxGroup]="
            this.getControl('extras.helpers.brstCervCancerSwOpt')
          "
          [referenceTable]="bccIndividualTable"
          [ariaRequired]="true"
          [globalLangTranslate]="false"
          [fromCheckboxList]="true"
          [readonlyControls]="brstCervCancerReadonlyControls"
        ></nh-checkbox-list>
      </div>
      }
      <nh-alert
        type="danger"
        [isOpen]="
          isY('extras.helpers.brstCervCancerSw') && !getCtrl('brstCervCancerSw')
        "
      >
        <div class="row">
          <div class="col-auto icon">
            <img
              src="../../../../../assets/images/Icons/⚛️ icons-alert-circle-outline.svg"
              alt=""
            />
          </div>
          <div class="col message">
            <span>{{ "REQUIRED" | globalTranslate }}</span>
          </div>
        </div>
      </nh-alert>
      <br />
    </div>
    @if (!isPreterm && !isPresumptive && showKb && isKbReferralSw()) {
    <section>
      <h2 class="section-header">Katie Beckett</h2>
      <hr />
      <nh-field
        id="otbe_kbReferralSw"
        [mandatory]="false"
        [attr.aria-required]="false"
        label="{{ 'OTHER_HEALTHCARE_STATIC_TEXT10' | globalTranslate }}"
        class="label-section"
      >
        <br />
        <div class="pt-1 hover-red">
          <a
            class="ps-0 text-left btn btn-link hover-red"
            tabindex="0"
            (click)="showMoreKatieBeckettProgramModal()"
          >
            <span style="padding-right: 8px">{{
              "OTHER_HEALTHCARE_STATIC_TEXT11" | globalTranslate
            }}</span>
            <span><i class="fa fa-external-link" aria-hidden="true"></i></span>
          </a>
        </div>
        <br />
        <select
          nhTranslate
          name="kbReferralSw"
          [attr.aria-label]="'OTHER_HEALTHCARE_STATIC_TEXT10' | globalTranslate"
          [items]="tableCodeValue('YESNO', 'data.kbReferralSw')"
          formControlName="kbReferralSw"
          [attr.disabled]="this.disableKb"
        ></select>
      </nh-field>
      <br />
    </section>
    } @if (isMedicalBillSw) {
    <section>
      <h2 class="section-header">
        {{ "OTHER_HEALTHCARE_STATIC_TEXT12" | globalTranslate }}
      </h2>
      <hr />
      <nh-field
        id="otbe_medicalBillSw"
        [mandatory]="false"
        [attr.aria-required]="false"
        label="{{ 'OTHER_HEALTHCARE_STATIC_TEXT13' | globalTranslate }}"
        class="label-section"
      >
        <nh-popover
          class="ps-1"
          [content]="'OTHER_HEALTHCARE_STATIC_TEXT16' | globalTranslate"
        ></nh-popover>
        <select
          nhTranslate
          name="medicalBillSw"
          [attr.aria-label]="'OTHER_HEALTHCARE_STATIC_TEXT13' | globalTranslate"
          (change)="onProfileDataChange('medicalBillSw', 'medicalBillsIndOpt')"
          [items]="tableCodeValue('YESNO', 'data.medicalBillSw')"
          formControlName="medicalBillSw"
          [attr.disabled]="isMedicalBillsDisabled ? true : null"
        ></select>
      </nh-field>
    </section>
    } @if (isY('data.medicalBillSw')) {
    <div>
      <label for="Medical Bills" class="label-section"
        ><span class="text-danger" aria-hidden="true">*&nbsp;</span
        >{{ "OTHER_HEALTHCARE_STATIC_TEXT5" | globalTranslate }}</label
      >
      <nh-checkbox-list
        uniqueString="MEDB"
        [checkboxGroup]="this.getControl('extras.helpers.medicalBillsIndOpt')"
        [disabled]="isCheckboxDisabled"
        [referenceTable]="
          changeMode ? medicalBillsIndvs : medicalBillsIndividualTable
        "
        [ariaRequired]="true"
        [globalLangTranslate]="false"
        [fromCheckboxList]="true"
      ></nh-checkbox-list>
    </div>
    }
    <nh-alert
      type="danger"
      [isOpen]="isY('data.medicalBillSw') && !getCtrl('medicalBillsIndSw')"
    >
      <div class="row">
        <div class="col-auto icon">
          <img
            src="../../../../../assets/images/Icons/⚛️ icons-alert-circle-outline.svg"
            alt=""
          />
        </div>
        <div class="col message">
          <span>{{ "REQUIRED" | globalTranslate }}</span>
        </div>
      </div>
    </nh-alert>
    <br />

    <h2 class="section-header">
      {{ "OTHER_HEALTHCARE_STATIC_TEXT14" | globalTranslate }}
    </h2>
    <hr />
    <nh-field
      id="otbe_medFacilitySw"
      [mandatory]="false"
      [attr.aria-required]="false"
      label="{{ 'OTHER_HEALTHCARE_STATIC_TEXT15' | globalTranslate }}"
      class="label-section"
    >
      <select
        nhTranslate
        name="medFacilitySw"
        [attr.aria-label]="'OTHER_HEALTHCARE_STATIC_TEXT15' | globalTranslate"
        (change)="onProfileDataChange('medFacilitySw', 'medFacilitySwOpt')"
        [items]="tableCodeValue('YESNO', 'extras.helpers.medFacilitySw')"
        [formControl]="getControl('extras.helpers.medFacilitySw')"
      ></select>
    </nh-field>
    @if (isY('extras.helpers.medFacilitySw')) {
    <div formArrayName="otherBenefitsIndvProfileData">
      <label for="Medical Facility" class="label-section"
        ><span class="text-danger" aria-hidden="true">*&nbsp;</span
        >{{ "OTHER_HEALTHCARE_STATIC_TEXT5" | globalTranslate }}</label
      >
      <nh-checkbox-list
        uniqueString="MED"
        [checkboxGroup]="this.getControl('extras.helpers.medFacilitySwOpt')"
        [referenceTable]="individualTable"
        [ariaRequired]="true"
        [globalLangTranslate]="false"
        [fromCheckboxList]="true"
      ></nh-checkbox-list>
      @for (row of otherBenefitsIndvProfileData.controls; track row; let i =
      $index) {
      <div class="mt-1" [formGroupName]="i">
        @if (isMedFacilitySw(row)) {
        <div>
          <br />
          <div>
            <strong
              >{{ "OTHER_HEALTHCARE_STATIC_TEXT17" | translate
              }}{{ getindividualsById(getValue("indvId", row))
              }}{{ "OTHER_HEALTHCARE_STATIC_TEXT18" | globalTranslate }}</strong
            >
          </div>
          <br />
          <nh-field
            id="otbe_medFacilityAdmitDt"
            label="{{ 'OTHER_HEALTHCARE_STATIC_TEXT19' | translate }}{{
              getindividualsById(getValue('indvId', row))
            }}{{ 'OTHER_HEALTHCARE_STATIC_TEXT20' | globalTranslate }}"
            class="label-section"
          >
            <nh-datepicker>
              <input
                type="text"
                class="form-control"
                name="medFacilityAdmitDt"
                (change)="isInvalidDate($event, i, row)"
                (bsValueChange)="isInvalidDate($event, i, row)"
                formControlName="medFacilityAdmitDt"
                [minDate]="$any(row).controls.minAdmitDate.value"
                [maxDate]="today"
                bsDatepicker
                nh
                maxlength="10"
              />
            </nh-datepicker>
          </nh-field>
          <br />
          <nh-field
            id="otbe_hospitalName"
            label="{{ 'OTHER_HEALTHCARE_STATIC_TEXT21' | globalTranslate }} {{
              getindividualsById(getValue('indvId', row))
            }}"
            class="label-section"
          >
            <input
              type="text"
              name="hospitalName"
              (change)="isInvalidName($event, row)"
              [attr.aria-label]="
                'OTHER_HEALTHCARE_STATIC_TEXT21' | globalTranslate
              "
              class="form-control"
              formControlName="hospitalName"
            />
          </nh-field>
        </div>
        }
      </div>
      }
    </div>
    }
    <nh-alert
      type="danger"
      [isOpen]="
        isY('extras.helpers.medFacilitySw') && !getCtrl('medFacilitySw')
      "
    >
      <div class="row">
        <div class="col-auto icon">
          <img
            src="../../../../../assets/images/Icons/⚛️ icons-alert-circle-outline.svg"
            alt=""
          />
        </div>
        <div class="col message">
          <span>{{ "REQUIRED" | globalTranslate }}</span>
        </div>
      </div>
    </nh-alert>
    <br />

    <h2 class="section-header">
      {{ "OTHER_HEALTHCARE_STATIC_TEXT22" | globalTranslate }}
    </h2>
    <hr />
    <nh-field
      id="otbe_nursingHomeSw"
      [mandatory]="false"
      [attr.aria-required]="false"
      label="{{ 'OTHER_HEALTHCARE_STATIC_TEXT23' | globalTranslate }}"
      class="label-section"
    >
      <select
        nhTranslate
        name="nursingHomeSw"
        [attr.aria-label]="'OTHER_HEALTHCARE_STATIC_TEXT23' | globalTranslate"
        (change)="onProfileDataChange('nursingHomeSw', 'nursingHomeSwOpt')"
        [items]="tableCodeValue('YESNO', 'extras.helpers.nursingHomeSw')"
        [formControl]="getControl('extras.helpers.nursingHomeSw')"
      ></select>
    </nh-field>

    <nh-alert type="warning" [isOpen]="isY('extras.helpers.nursingHomeSw')">
      <div class="row">
        <div class="col-auto icon">
          <img
            src="../../../../../assets/images/Icons/⚛️ icons-warning-outline.svg"
            alt=""
          />
        </div>
        <div class="col message">
          <span
            >{{ "OTHER_HEALTHCARE_STATIC_TEXT25" | globalTranslate }}&nbsp;
          </span>
        </div>
      </div>
    </nh-alert>

    @if (isY('extras.helpers.nursingHomeSw')) {
    <div formArrayName="otherBenefitsIndvProfileData">
      <label for="Nursing Home" class="label-section"
        ><span class="text-danger" aria-hidden="true">*&nbsp;</span
        >{{ "OTHER_HEALTHCARE_STATIC_TEXT5" | globalTranslate }}</label
      >
      <nh-checkbox-list
        uniqueString="NRG"
        [checkboxGroup]="this.getControl('extras.helpers.nursingHomeSwOpt')"
        [referenceTable]="individualTable"
        [ariaRequired]="true"
        [globalLangTranslate]="false"
        [fromCheckboxList]="true"
      ></nh-checkbox-list>
      @for (row of otherBenefitsIndvProfileData.controls; track row; let i =
      $index) {
      <div class="mt-1" [formGroupName]="i">
        @if (isNursingHomeSw(row)) {
        <div>
          <br />
          <nh-field
            [mandatory]="false"
            [attr.aria-required]="false"
            id="otbe_nursingHomeAdmitDt"
            label="{{ 'OTHER_HEALTHCARE_STATIC_TEXT19' | translate }}{{
              getindividualsById(getValue('indvId', row))
            }}{{ 'OTHER_HEALTHCARE_STATIC_TEXT20' | globalTranslate }}"
            class="label-section"
          >
            <nh-datepicker>
              <input
                type="text"
                class="form-control"
                name="nursingHomeAdmitDt"
                (change)="isInvalidDate($event, i, row)"
                formControlName="nursingHomeAdmitDt"
                (bsValueChange)="isInvalidDate($event, i, row)"
                [minDate]="$any(row).controls.minAdmitDate.value"
                [maxDate]="today"
                bsDatepicker
                nh
                maxlength="10"
              />
            </nh-datepicker>
          </nh-field>
          <br />
          <nh-field
            id="otbe_nursingHomeName"
            label="{{ 'OTHER_HEALTHCARE_STATIC_TEXT24' | globalTranslate }}"
            class="label-section"
          >
            <input
              type="text"
              name="nursingHomeName"
              (change)="isInvalidName($event, row)"
              [attr.aria-label]="
                'OTHER_HEALTHCARE_STATIC_TEXT24' | globalTranslate
              "
              class="form-control"
              formControlName="nursingHomeName"
            />
          </nh-field>
        </div>
        }
      </div>
      }
    </div>
    }
    <nh-alert
      type="danger"
      [isOpen]="
        isY('extras.helpers.nursingHomeSw') && !getCtrl('nursingHomeSw')
      "
    >
      <div class="row">
        <div class="col-auto icon">
          <img
            src="../../../../../assets/images/Icons/⚛️ icons-alert-circle-outline.svg"
            alt=""
          />
        </div>
        <div class="col message">
          <span>{{ "REQUIRED" | globalTranslate }}</span>
        </div>
      </div>
    </nh-alert>
    <br />

    <h2 class="section-header">
      {{ "OTHER_HEALTHCARE_STATIC_TEXT26" | globalTranslate }}
    </h2>
    <hr />
    <nh-field
      id="otbe_hospiceSw"
      [mandatory]="false"
      [attr.aria-required]="false"
      label="{{ 'OTHER_HEALTHCARE_STATIC_TEXT27' | globalTranslate }}"
      class="label-section"
    >
      <select
        nhTranslate
        name="hospiceSw"
        [attr.aria-label]="'OTHER_HEALTHCARE_STATIC_TEXT27' | globalTranslate"
        (change)="onProfileDataChange('hospiceSw', 'hospiceSwOpt')"
        [items]="tableCodeValue('YESNO', 'extras.helpers.hospiceSw')"
        [formControl]="getControl('extras.helpers.hospiceSw')"
      ></select>
    </nh-field>
    @if (isY('extras.helpers.hospiceSw')) {
    <div>
      <label for="Hospice Care" class="label-section"
        ><span class="text-danger" aria-hidden="true">*&nbsp;</span
        >{{ "OTHER_HEALTHCARE_STATIC_TEXT5" | globalTranslate }}</label
      >
      <nh-checkbox-list
        uniqueString="HPC"
        [checkboxGroup]="this.getControl('extras.helpers.hospiceSwOpt')"
        [referenceTable]="individualTable"
        [ariaRequired]="true"
        [globalLangTranslate]="false"
        [fromCheckboxList]="true"
      ></nh-checkbox-list>
    </div>
    }
    <nh-alert
      type="danger"
      [isOpen]="isY('extras.helpers.hospiceSw') && !getCtrl('hospiceSw')"
    >
      <div class="row">
        <div class="col-auto icon">
          <img
            src="../../../../../assets/images/Icons/⚛️ icons-alert-circle-outline.svg"
            alt=""
          />
        </div>
        <div class="col message">
          <span>{{ "REQUIRED" | globalTranslate }}</span>
        </div>
      </div>
    </nh-alert>
    <br />

    <h2 class="section-header">
      {{ "OTHER_HEALTHCARE_STATIC_TEXT28" | globalTranslate }}
    </h2>
    <hr />
    <nh-field
      id="otbe_hcbsSw"
      [mandatory]="false"
      [attr.aria-required]="false"
      label="{{ 'OTHER_HEALTHCARE_STATIC_TEXT29' | globalTranslate }}"
      class="label-section"
    >
      <nh-popover
        class="ps-1"
        [content]="'OTHER_HEALTHCARE_STATIC_TEXT30' | globalTranslate"
      ></nh-popover>
      <select
        nhTranslate
        name="hcbsSw"
        [attr.aria-label]="'OTHER_HEALTHCARE_STATIC_TEXT29' | globalTranslate"
        (change)="onProfileDataChange('hcbsSw', 'hcbsSwOpt')"
        [items]="tableCodeValue('YESNO', 'extras.helpers.hcbsSw')"
        [formControl]="getControl('extras.helpers.hcbsSw')"
      ></select>
    </nh-field>
    <nh-alert type="warning" [isOpen]="isY('extras.helpers.hcbsSw')">
      <div class="row">
        <div class="col-auto icon">
          <img
            src="../../../../../assets/images/Icons/⚛️ icons-warning-outline.svg"
            alt=""
          />
        </div>
        <div class="col message">
          <span
            >{{ "OTHER_HEALTHCARE_STATIC_TEXT47" | globalTranslate }}&nbsp;
          </span>
        </div>
      </div>
    </nh-alert>
    @if (isY('extras.helpers.hcbsSw')) {
    <div>
      <label class="label-section" for="HCBS"
        ><span class="text-danger" aria-hidden="true">*&nbsp;</span
        >{{ "OTHER_HEALTHCARE_STATIC_TEXT5" | globalTranslate }}</label
      >
      <nh-checkbox-list
        uniqueString="HCBS"
        [checkboxGroup]="this.getControl('extras.helpers.hcbsSwOpt')"
        [referenceTable]="individualTable"
        [ariaRequired]="true"
        [globalLangTranslate]="false"
        [fromCheckboxList]="true"
      ></nh-checkbox-list>
    </div>
    }
    <nh-alert
      type="danger"
      [isOpen]="isY('extras.helpers.hcbsSw') && !getCtrl('hcbsSw')"
    >
      <div class="row">
        <div class="col-auto icon">
          <img
            src="../../../../../assets/images/Icons/⚛️ icons-alert-circle-outline.svg"
            alt=""
          />
        </div>
        <div class="col message">
          <span>{{ "REQUIRED" | globalTranslate }}</span>
        </div>
      </div>
    </nh-alert>
    <br />

    <section>
      <h2 class="section-header">
        {{ "OTHER_HEALTHCARE_STATIC_TEXT31" | globalTranslate }}
      </h2>
      <hr />
      <nh-field
        id="otbe_ecfSw"
        [mandatory]="false"
        [attr.aria-required]="false"
        label="{{ 'OTHER_HEALTHCARE_STATIC_TEXT32' | globalTranslate }}"
        class="label-section"
      >
        <nh-popover
          class="ps-1"
          [content]="'OTHER_HEALTHCARE_STATIC_TEXT33' | globalTranslate"
        ></nh-popover>
        <select
          nhTranslate
          name="ecfSw"
          [attr.aria-label]="'OTHER_HEALTHCARE_STATIC_TEXT32' | globalTranslate"
          (change)="onProfileDataChange('ecfSw', 'ecfIndSwOpt')"
          [items]="tableCodeValue('YESNO', 'extras.helpers.ecfSw')"
          [formControl]="getControl('extras.helpers.ecfSw')"
        ></select>
      </nh-field>
      <nh-alert type="warning" [isOpen]="isY('extras.helpers.ecfSw')">
        <div class="row">
          <div class="col-auto icon">
            <img
              src="../../../../../assets/images/Icons/⚛️ icons-warning-outline.svg"
              alt=""
            />
          </div>
          <div class="col message">
            <span
              >{{ "OTHER_HEALTHCARE_STATIC_TEXT48" | globalTranslate }}&nbsp;
            </span>
          </div>
        </div>
      </nh-alert>
    </section>
    @if (isY('extras.helpers.ecfSw')) {
    <div>
      <label for="ECF" class="label-section"
        ><span class="text-danger" aria-hidden="true">*&nbsp;</span
        >{{ "OTHER_HEALTHCARE_STATIC_TEXT5" | globalTranslate }}</label
      >
      <nh-checkbox-list
        uniqueString="ECF"
        [checkboxGroup]="getControl('extras.helpers.ecfIndSwOpt')"
        [referenceTable]="individualTable"
        [ariaRequired]="true"
        [globalLangTranslate]="false"
        [fromCheckboxList]="true"
      ></nh-checkbox-list>
    </div>
    }
    <nh-alert
      type="danger"
      [isOpen]="isY('extras.helpers.ecfSw') && !getCtrl('ecfSw')"
    >
      <div class="row">
        <div class="col-auto icon">
          <img
            src="../../../../../assets/images/Icons/⚛️ icons-alert-circle-outline.svg"
            alt=""
          />
        </div>
        <div class="col message">
          <span>{{ "REQUIRED" | globalTranslate }}</span>
        </div>
      </div>
    </nh-alert>
    <br />

    <h2 class="section-header">
      {{ "OTHER_HEALTHCARE_STATIC_TEXT34" | globalTranslate }}
    </h2>
    <hr />
    <nh-field
      id="otbe_intelDisbSw"
      [mandatory]="false"
      [attr.aria-required]="false"
      label="{{ 'OTHER_HEALTHCARE_STATIC_TEXT35' | globalTranslate }}"
      class="label-section"
    >
      <select
        nhTranslate
        name="intelDisbSw"
        [attr.aria-label]="'OTHER_HEALTHCARE_STATIC_TEXT35' | globalTranslate"
        (change)="onProfileDataChange('intelDisbSw', 'intelDisbSwOpt')"
        [items]="tableCodeValue('YESNO', 'extras.helpers.intelDisbSw')"
        [formControl]="getControl('extras.helpers.intelDisbSw')"
      ></select>
    </nh-field>
    @if (isY('extras.helpers.intelDisbSw')) {
    <div>
      <label for="IMC" class="label-section"
        ><span class="text-danger" aria-hidden="true">*&nbsp;</span
        >{{ "OTHER_HEALTHCARE_STATIC_TEXT5" | globalTranslate }}</label
      >
      <nh-checkbox-list
        uniqueString="IMC"
        [checkboxGroup]="this.getControl('extras.helpers.intelDisbSwOpt')"
        [referenceTable]="individualTable"
        [ariaRequired]="true"
        [globalLangTranslate]="false"
        [fromCheckboxList]="true"
      ></nh-checkbox-list>
    </div>
    }
    <nh-alert
      type="danger"
      [isOpen]="isY('extras.helpers.intelDisbSw') && !getCtrl('intelDisbSw')"
    >
      <div class="row">
        <div class="col-auto icon">
          <img
            src="../../../../../assets/images/Icons/⚛️ icons-alert-circle-outline.svg"
            alt=""
          />
        </div>
        <div class="col message">
          <span>{{ "REQUIRED" | globalTranslate }}</span>
        </div>
      </div>
    </nh-alert>
    <br />

    <!-- Transfer Resources -->
    @if (showTransferResources()) {
    <div>
      <h2 class="section-header">
        {{ "OTHER_HEALTHCARE_STATIC_TEXT44" | globalTranslate }}
      </h2>
      <hr />
      @if (!isPresumptive) {
      <nh-field
        id="otbe_transferInd"
        [mandatory]="true"
        [attr.aria-required]="true"
        label="{{ 'OTHER_HEALTHCARE_STATIC_TEXT45' | globalTranslate }}"
        class="label-section"
      >
        <nh-popover
          class="ps-1"
          [content]="'OTHER_HEALTHCARE_STATIC_TEXT46' | globalTranslate"
        ></nh-popover>
        <select
          nhTranslate
          name="transferredResInd"
          [attr.aria-label]="'OTHER_HEALTHCARE_STATIC_TEXT45' | globalTranslate"
          [items]="tableCodeValue('YESNO', 'data.transferredResInd')"
          [attr.disabled]="isTransferDisabled ? true : null"
          formControlName="transferredResInd"
          (change)="onTransfer($event)"
          required
        ></select>
      </nh-field>
      } @if (isPresumptive) {
      <nh-field
        id="otbe_transferInd"
        [mandatory]="true"
        [attr.aria-required]="true"
        label="{{ 'OTHER_HEALTHCARE_STATIC_TEXT45' | globalTranslate }}"
        class="label-section"
      >
        <nh-popover
          class="ps-1"
          [content]="'OTHER_HEALTHCARE_STATIC_TEXT46' | globalTranslate"
        ></nh-popover>
        <select
          nhTranslate
          name="transferredResIndSw"
          [items]="
            tableCodeValue('YESNO', 'extras.helpers.transferredResIndSw')
          "
          (change)="
            onProfileDataChange('transferredResIndSw', 'transferIndOpt')
          "
          [attr.aria-label]="'OTHER_HEALTHCARE_STATIC_TEXT45' | globalTranslate"
          [formControl]="getControl('extras.helpers.transferredResIndSw')"
          required
        ></select>
      </nh-field>
      }
      <br />
      @if (isY('extras.helpers.transferredResIndSw') && isPresumptive) {
      <div>
        <label for="Expenses" class="label-section"
          ><span class="text-danger" aria-hidden="true">*&nbsp;</span
          >{{ "OTHER_HEALTHCARE_STATIC_TEXT5" | globalTranslate }}</label
        >
        <nh-checkbox-list
          uniqueString="TRANS"
          [checkboxGroup]="this.getControl('extras.helpers.transferIndOpt')"
          [referenceTable]="individualTable"
          [ariaRequired]="true"
          [globalLangTranslate]="false"
          [fromCheckboxList]="true"
        ></nh-checkbox-list>
      </div>
      }
      <nh-alert
        type="danger"
        [isOpen]="
          isY('extras.helpers.transferredResIndSw') &&
          isPresumptive &&
          !getCtrl('transferredResIndSw')
        "
      >
        <div class="row">
          <div class="col-auto icon">
            <img
              src="../../../../../assets/images/Icons/⚛️ icons-alert-circle-outline.svg"
              alt=""
            />
          </div>
          <div class="col message">
            <span>{{ "REQUIRED" | globalTranslate }}</span>
          </div>
        </div>
      </nh-alert>
    </div>
    } @if (showExpenseResources()) {
    <div>
      <h2 class="section-header">
        {{ "OTHER_HEALTHCARE_STATIC_TEXT36" | globalTranslate }}
      </h2>
      <hr />
      @if (!isPresumptive) {
      <nh-field
        id="otbe_expensesInd"
        [mandatory]="false"
        [attr.aria-required]="false"
        label="{{ 'OTHER_HEALTHCARE_STATIC_TEXT37' | globalTranslate }}"
        class="label-section"
      >
        <select
          nhTranslate
          name="expensesIndSw"
          [attr.aria-label]="'OTHER_HEALTHCARE_STATIC_TEXT37' | globalTranslate"
          [items]="tableCodeValue('YESNO', 'data.expensesInd')"
          [attr.disabled]="isExpensesDisabled ? true : null"
          formControlName="expensesInd"
        ></select>
      </nh-field>
      } @if (isPresumptive) {
      <nh-field
        id="otbe_expensesInd"
        [mandatory]="false"
        [attr.aria-required]="false"
        label="{{ 'OTHER_HEALTHCARE_STATIC_TEXT37' | globalTranslate }}"
        class="label-section"
      >
        <select
          nhTranslate
          name="expensesIndSw"
          [items]="tableCodeValue('YESNO', 'extras.helpers.expensesIndSw')"
          (change)="onProfileDataChange('expensesIndSw', 'expensesIndOpt')"
          [attr.aria-label]="'OTHER_HEALTHCARE_STATIC_TEXT37' | globalTranslate"
          [formControl]="getControl('extras.helpers.expensesIndSw')"
        ></select>
      </nh-field>
      }
      <br />
      @if (isY('extras.helpers.expensesIndSw') && isPresumptive) {
      <div>
        <label for="Expenses" class="label-section"
          ><span class="text-danger" aria-hidden="true">*&nbsp;</span
          >{{ "OTHER_HEALTHCARE_STATIC_TEXT5" | globalTranslate }}</label
        >
        <nh-checkbox-list
          uniqueString="EXPI"
          [checkboxGroup]="this.getControl('extras.helpers.expensesIndOpt')"
          [referenceTable]="individualTable"
          [ariaRequired]="true"
          [globalLangTranslate]="false"
          [fromCheckboxList]="true"
        ></nh-checkbox-list>
      </div>
      }
      <nh-alert
        type="danger"
        [isOpen]="
          isY('extras.helpers.expensesIndSw') &&
          isPresumptive &&
          !getCtrl('expensesIndSw')
        "
      >
        <div class="row">
          <div class="col-auto icon">
            <img
              src="../../../../../assets/images/Icons/⚛️ icons-alert-circle-outline.svg"
              alt=""
            />
          </div>
          <div class="col message">
            <span>{{ "REQUIRED" | globalTranslate }}</span>
          </div>
        </div>
      </nh-alert>
    </div>
    } @if (showExpenseResources()) {
    <section>
      <h2 class="section-header">
        {{ "OTHER_HEALTHCARE_STATIC_TEXT38" | globalTranslate }}
      </h2>
      <hr />
      @if (!isPresumptive) {
      <nh-field
        id="otbe_assetIndSw"
        [mandatory]="false"
        [attr.aria-required]="false"
        label="{{ 'OTHER_HEALTHCARE_STATIC_TEXT39' | globalTranslate }}"
        class="label-section"
      >
        <select
          nhTranslate
          name="assetIndSw"
          [attr.aria-label]="'OTHER_HEALTHCARE_STATIC_TEXT39' | globalTranslate"
          [attr.disabled]="isResoursesDisabled ? true : null"
          [items]="tableCodeValue('YESNO', 'data.assetInd')"
          formControlName="assetInd"
        ></select>
      </nh-field>
      } @if (isPresumptive) {
      <nh-field
        id="otbe_assetIndSw"
        [mandatory]="false"
        [attr.aria-required]="false"
        label="Does anyone in your household have resources like financial accounts, 
      vehicles, property, burial resources, or life insurance?"
        class="label-section"
      >
        <select
          nhTranslate
          name="assetIndSw"
          aria-label="Does anyone in your household have resources like financial accounts, 
      vehicles, property, burial resources, or life insurance?"
          [items]="tableCodeValue('YESNO', 'extras.helpers.assetIndSw')"
          (change)="onProfileDataChange('assetIndSw', 'assetIndSwOpt')"
          [formControl]="getControl('extras.helpers.assetIndSw')"
        ></select>
      </nh-field>
      }
      <br />
      @if (isY('extras.helpers.assetIndSw') && this.isPresumptive) {
      <div>
        <label for="Resources" class="label-section"
          ><span class="text-danger" aria-hidden="true">*&nbsp;</span
          >{{ "OTHER_HEALTHCARE_STATIC_TEXT5" | globalTranslate }}</label
        >
        <nh-checkbox-list
          uniqueString="ASI"
          [checkboxGroup]="this.getControl('extras.helpers.assetIndSwOpt')"
          [referenceTable]="individualTable"
          [ariaRequired]="true"
          [globalLangTranslate]="false"
          [fromCheckboxList]="true"
        ></nh-checkbox-list>
      </div>
      }
      <nh-alert
        type="danger"
        [isOpen]="
          isY('extras.helpers.assetIndSw') &&
          this.isPresumptive &&
          !getCtrl('assetIndSw')
        "
      >
        <div class="row">
          <div class="col-auto icon">
            <img
              src="../../../../../assets/images/Icons/⚛️ icons-alert-circle-outline.svg"
              alt=""
            />
          </div>
          <div class="col message">
            <span>{{ "REQUIRED" | globalTranslate }}</span>
          </div>
        </div>
      </nh-alert>
    </section>
    }
  </section>
</nh-form>